var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstitutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 21.8376V14.2251M13.05 21.8376V10.9626M4.35 21.8376L4.35 17.4876M14.5798 5.55501L20.2004 7.66276M11.7437 5.9611L5.65525 10.5274M22.9035 7.09038C23.5405 7.72742 23.5405 8.76027 22.9035 9.39732C22.2664 10.0344 21.2336 10.0344 20.5965 9.39732C19.9595 8.76027 19.9595 7.72742 20.5965 7.09038C21.2336 6.45334 22.2664 6.45334 22.9035 7.09038ZM5.50347 10.3529C6.14051 10.9899 6.14051 12.0228 5.50347 12.6598C4.86643 13.2969 3.83357 13.2969 3.19653 12.6598C2.55949 12.0228 2.55949 10.9899 3.19653 10.3529C3.83357 9.71584 4.86643 9.71584 5.50347 10.3529ZM14.2035 3.82788C14.8405 4.46492 14.8405 5.49777 14.2035 6.13482C13.5664 6.77186 12.5336 6.77186 11.8965 6.13482C11.2595 5.49777 11.2595 4.46492 11.8965 3.82788C12.5336 3.19084 13.5664 3.19084 14.2035 3.82788Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutions);
export default __webpack_public_path__ + "static/media/institutions.d5af56255edf9abf5cd7b940cae27f68.svg";
export { ForwardRef as ReactComponent };